import { Facet } from '@aipb/gulliver/catalog/model';
import { ScoreComponent } from '@aipb/gulliver/catalog/ui';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'cat-facet-list-item',
  templateUrl: './facet-list-item.component.html',
  styleUrls: ['./facet-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatCheckboxModule, ScoreComponent]
})
export class FacetListItemComponent {
  @Input() fieldId: string;
  @Input() item: Facet;

  @Output() toggle = new EventEmitter<[string, Facet]>();
}
